import React, {useState, useEffect} from 'react';
import QuantityInputFontAwesome from '../../../ReposLib/src/UI/QuantityInput/QuantityInputFontAwesome.js';
import * as Products from '../../../libraries/Products.js';
import Actions from '../../../actions/Actions.js';
import Remove from './Remove';

const Quantity = (props)=> {
  const [step,setStep] = useState(1);
  useEffect(()=>{
    setStep(Products.getStep(props.item));
  },[props.item,props.product_config]);

  const quantityChanged = (value) =>{
    Actions.productUpdate({item:props.item,id:props.variant_id,quantity:value});
  };

  const quantityRemove = (value) =>{
    Actions.productUpdate({item:props.item,id:props.variant_id,quantity:0});
  };
  
  return (
    <>
      <QuantityInputFontAwesome
        value={props.quantity} 
        quantityChanged     = {quantityChanged}
        quantityRemove      = {quantityRemove}
        classNameContainer  = {"quantity_container"}
        classNameInput      = {"quantity"}
        classNameButtonMinus= {"icon minus"}
        classNameButtonPlus = {"icon plus"}
        step={step}
        item={props.item}
      />
      <Remove
        item={props.item}
        variant_id={props.variant_id}
        class="mt-2"
      />
    </>
  )
}
export default Quantity;